<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 header">
      <img src="../../../assets/idall-tools-logo.png" width="60" height="60"/>
      <h2>iDall OAuth Tools</h2>
      <span class="mx-5 mt-1 d-inline-block text-secondary">version {{version}}</span>
    </div>
  </div>
  <div class="row" style="height: 100%">
    <div class="col-md-2 sidebar" style="padding: 20px">
      <div class="container">
        <div class="row">
          <p>
            Button with a badge on the left
            <button mat-raised-button color="accent" style="background: #008b8b">
              CODE
            </button>
            <span class="text-white ml-2">Code Flow</span>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-6 content">
      <form (ngSubmit)="submitCodeFlow()" [formGroup]="codeFlowForm">
        <div>
          <h1>Authorization Code Flow</h1>
        </div>
        <div class="section">
          <p>Configure your client with the following redirect uri: </p>
          <div>
            <span class="redirectUri">{{redirectUri}}</span>
            <mat-icon  [cdkCopyToClipboard]="redirectUri" class="copy-to-clipboard ml-3" matTooltip="copy to clipboard">
              content_copy
            </mat-icon>
          </div>
        </div>
        <div class="section">
          <h2>Settings</h2>
          <div class="row">

            <div class="col-6">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select an issuer</mat-label>
                <mat-select formControlName="issuer">
                  <mat-option *ngFor="let issuer of issuerList" [value]="issuer">{{issuer}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-6">

              <mat-form-field class="full-width" appearance="outline">
                <mat-label>Select or Enter Client ID</mat-label>
                <label>
                  <input type="text"
                         matInput
                         formControlName="clientId"
                         [matAutocomplete]="clientIdAuto"
                         (keydown.enter)="enterClientId($event)">
                </label>
                <mat-autocomplete #clientIdAuto="matAutocomplete">
                  <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
                              style="display: flex ; align-items: center ; flex-direction: row ; justify-content: space-between ; width: 100%">
                    {{option}}
<!--                    <mat-icon (click)="deleteClientId($event,option)" style="float: right ; line-height: 58px">close</mat-icon>-->
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            </div>

            <div class="col-6">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Enter Client Secret</mat-label>
                <label>
                  <input matInput [type]="hide ? 'password' : 'text'" formControlName="dummyClientSecret">
                </label>
                <button mat-icon-button matSuffix mat-button (click)="hideIcon($event)"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <mat-form-field class="full-width" appearance="outline">
                <mat-chip-list #chipList>
                  <mat-chip
                    *ngFor="let scope of scopes"
                    [selectable]="true"
                    [removable]="true"
                    (removed)="remove(scope)">
                    {{scope}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    placeholder="Select or add scope"
                    formControlName="scope"
                    #scopeInput
                    [matAutocomplete]="scopeAuto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
                <mat-autocomplete #scopeAuto="matAutocomplete" (optionSelected)="selected($event)">
                  <mat-option *ngFor="let scope of filteredScopes | async" [value]="scope">
                    {{scope}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="row mt-3 ml-1">
            <div class="col-md-6">
              <mat-slide-toggle formControlName="disablePKCE">
                Use PKCE
              </mat-slide-toggle>
            </div>
            <div class="col-md-6">
              <mat-slide-toggle formControlName="promptLogin">
                Prompt Login
              </mat-slide-toggle>
            </div>
            <!--            <div class="col-md-6">-->
            <!--              <mat-slide-toggle formControlName="iframe">-->
            <!--                Open in iFrame-->
            <!--              </mat-slide-toggle>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="section">
          <button class="btn btn-success btn-block" type="submit">Get Token</button>
        </div>
      </form>
    </div>
    <div class="col-md-4" style="padding: 20px; height: 100% ; overflow: auto">
      <div class="ml-3">
        <div class="row">
          <mat-label class="mat-label-textarea">id_token</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <textarea matInput [(ngModel)]="id_token" rows="10" style="font-size: 12px;"
                      [mat-autosize]="false"></textarea>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-label class="mat-label-textarea">access_token</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <button mat-icon-button matSuffix>
              <mat-icon [cdkCopyToClipboard]="access_token" class="copy-to-clipboard" matTooltip="copy to clipboard">
                content_copy
              </mat-icon>
            </button>
            <textarea matInput [(ngModel)]="access_token" style="font-size: 12px;" rows="8"
                      [mat-autosize]="false"></textarea>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-label class="mat-label-textarea">expires_in</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <textarea matInput [mat-autosize]="false">{{expire_in}}</textarea>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-label class="mat-label-textarea">refresh_token</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <button mat-icon-button matSuffix>
              <mat-icon [cdkCopyToClipboard]="access_token" class="copy-to-clipboard" matTooltip="copy to clipboard">
                content_copy
              </mat-icon>
            </button>
            <textarea matInput [(ngModel)]="refresh_token" [mat-autosize]="false"></textarea>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-label class="mat-label-textarea">scope</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <textarea matInput [(ngModel)]="getGrantedScopes" [mat-autosize]="false"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
